<template>
  <div :class="['app', weatherBg]">
    <main>
      <!-- Search -->
      <div class="search-box">
        <input
          type="text"
          class="search-bar"
          placeholder="Search city..."
          v-model="query"
          @keyup.enter="getWeather"
        />
      </div>

      <!-- Weather Info -->
      <div v-if="weather.main" class="weather-wrap">
        <div class="location">
          {{ weather.name }}, {{ weather.sys.country }}
        </div>

        <div class="date">
          {{ currentDate() }}
        </div>

        <div class="temp">
          {{ Math.round(weather.main.temp) }}°c
        </div>

        <div class="weather">
          {{ weather.weather[0].main }}
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      api_key: 'fc4d96fb3a7a146eb4648bfe5031e2b9',
      url_base: "https://api.openweathermap.org/data/2.5/",
      query: "",
      weather: {}
    };
  },

  computed: {
    weatherBg() {
      if (!this.weather.main) return "cold";
      return this.weather.main.temp > 20 ? "hot" : "cold";
    }
  },

  methods: {
    getWeather() {
      fetch(
        `${this.url_base}weather?q=${this.query}&units=metric&appid=${this.api_key}`
      )
        .then(res => res.json())
        .then(data => {
          this.weather = data;
        });
    },

    currentDate() {
      const d = new Date();
      return d.toDateString();
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
}

.app {
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  transition: 0.4s;
}

/* COLD BACKGROUND */
.cold {
  background-image: linear-gradient(
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0.6)
    ),
   url('./assets/warm.jpg');
}

/* HOT BACKGROUND */
.hot {
  background-image: linear-gradient(
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0.6)
    ),
   url('./assets/cold.jpg');
}

main {
  padding: 25px;
  text-align: center;
  color: #fff;
}

/* Search */
.search-box {
  margin-bottom: 30px;
}

.search-bar {
  width: 100%;
  max-width: 300px;
  padding: 12px 15px;
  border-radius: 25px;
  border: none;
  outline: none;
  font-size: 16px;
}

/* Weather Display */
.location {
  font-size: 24px;
  font-weight: 600;
}

.date {
  font-size: 14px;
  margin-bottom: 20px;
}

.temp {
  font-size: 80px;
  font-weight: bold;
  margin: 20px 0;
}

.weather {
  font-size: 28px;
  font-style: italic;
}
</style>
